import { Note } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';
import { EntityKeyByNumber } from './keys/entity-key';
import { EntityKeyByReference } from '@card-software/library';
import { LotItem } from './lot-item';

export enum InventoryTransactionStatus {
  Draft,
  InRoute,
  Received,
  Rejected,
  InRouteBack,
  Voided,
}

export enum InventoryTransactionType {
  Transfer,
  Receipt,
  Adjustment,
  Consumption,
}

export interface InventoryTransaction extends AuditTrail {
  /** Descends from an Administrative purchase order (#5942); only role holders can see it, the API enforces. */
  isAdministrative?: boolean;
  id?: string;
  status: number;
  initiator: EntityKeyByReference;
  transactionType: number;
  fromLocationCode?: string;
  toLocationCode?: string;
  lines: InventoryTransactionLine[];
  notes: Note[];
}

export interface InventoryTransactionLine {
  id?: string;
  lotItemKey?: EntityKeyByNumber;
  lotItem?: LotItem;
  itemCode?: string;
  quantity: number;
  uom: number;
  executedAt: Date;
  fromLocationCode?: string;
  toLocationCode?: string;
}

export interface NewInventoryTransaction extends Omit<InventoryTransaction, 'id'> {
  id?: undefined;
}
